import prodexpVendorService from "../../services/prodexpvendor";
const getDefaultState = () => {
    return {
        ProdExpVendor: {
            ID: 0,
            RequestType: null,
            Title: null,
            Phone: null,
            EmployeeAgency: null,
            AgencyName: null,
            VendorBusinessName: null,
            IdentificationType: null,
            IdentificationName: null,
            USTaxID: null,
            Foreign: null,
            SocialSecurityNumber: null,
            IdentificationFiles: [],
            attachement: [],
            ACH: null,
            Country: null,
            AdrsLine1: null,
            ProductService: null,
            Businessdollars: null,
            Compensation: null,
            Accept: null,
            Vendor: [],
            SetupInfo: [],
            ServiceInfoFiles: [],
            ExternalVendorFiles: [],
            WireInfoSheets: [],
            CompletedForms: [],
            AdditionalApproval: null,
            CompensationDollers: null,
            EmployeeVendorRelationship: [],
            AnyGiftOrCompensationOfferedToYouToPlaceOrder: null,
            TypeOfProductOrServiceProvidedByVendor: null,
            DollarsAnticipatedToConductAnnuallyByVendor: null,
            RemittanceAdviceEmail: null,
            EmployeeTitle: null,
            EmployeePhoneNumber: null,
            EmployeeVendorRelationshipDetails: {
                ID: 0,
                FormerEmployeeName: null,
                FamilyMemberName: null,
                FriendName: null,
                VendorRelationshipWithAgencyClient: null,
                VendorOfFormerEmployee: null,
                VendorWasFormerEmployeeOfAgency: null,
                VendorHasRelationshipWithAnotherAgencyEmployee: null,
                Other: null,
                ProductionVendorRequestID: 0
            },
            Status: null,
            InfoFromName: null,
            InfoFromTitle: null,
            InfoFromPhone: null,
            InvoicesImmediatePayment: null,
            Requestor: null,
            UpdatedBy: null,
            CreatedDate: null,
            UpdatedDate: null,
            OmniflowProjectID: null,
            OmniflowProcessID: null,
            CompletionDate: null,
            InActive: null,
            Files: [],
            IsEditDataLoaded: false,
            IsVendorReceive1099: null,
            IsIssuedNameEIN: null,
            IssuedName: null,
            VendorTIN: null,
            HasBankLetterInvoice: null,
            BankName: null,
            BankCountry: null,
            BankAddressLine1: null,
            BankAddressLine2: null,
            BankCity: null,
            BankState: null,
            BankZipCode: null,
            BankAccountName: null,
            BankAccountNumber: null,
            BankRoutingNumber: null,
            BankIBAN: null,
            BankSWIFTCode: null,
            InvoiceCopies: [],
            FormerEmployeeReimbursement: null,
            Entity: null,
            EntityName: null,
            VendorRemittanceName: null,
            RemittanceCountry: null,
            StreetAddressLine1: null,
            StreetAddressLine2: null,
            RemittanceCity: null,
            RemittanceState: null,
            RemittanceZipCode: null,
            RemittanceEmail: null,
            IsVendorWebsiteProvided: null,
            VendorWebsiteLink: null,
            MediaKitAttachments: [],
            IsPaidByWire: null,
            IsACHPayment: null,
            CreditCardFiles: [],
            VendorConfirmationEmail: [],
        },
    };
};

// initial state
const state = getDefaultState();

// getters
const getters = {
    ProdExpVendor: (state) => {
        return state.ProdExpVendor;
    },
};

// actions
const actions = {
    async GetFormData(st, id) {
        await prodexpVendorService
            .GetFormData(id, st.rootState.auth.idToken)
            .then((res) => {
                st.commit("loadVendorData", res.data);
                st.commit("loadVendorFiles", res.data);
                return res.data;
            })
            .catch((err) => {
                throw err;
            });
    },
    AddRequestWithFiles(st, data) {
        return prodexpVendorService.AddRequestWithFiles(
            data,
            st.rootState.auth.idToken
        );
    },
    UpdateRequestWithFiles(st, { id, data }) {
        return prodexpVendorService.UpdateRequestWithFiles(
            id,
            data,
            st.rootState.auth.idToken
        );
    },
    GetRequestWithTaskDetails(st, id) {
        return prodexpVendorService.GetProductionVendorRequestWithTaskDetails(
            id,
            st.rootState.auth.idToken
        );
    },

    ApproveProdExpenseRequestLevel1(st, data) {
        return prodexpVendorService.ApproveProdExpVendorRequestLevel1(
            data,
            st.rootState.auth.idToken
        );
    },
    RejectProdExpVendorRequestLevel1(st, data) {
        return prodexpVendorService.RejectProdExpVendorRequestLevel1(
            data,
            st.rootState.auth.idToken
        );
    },
    ApproveProdExpenseRequestLevel2(st, data) {
        return prodexpVendorService.ApproveProdExpVendorRequestLevel2(
            data,
            st.rootState.auth.idToken
        );
    },
    RejectProdExpVendorRequestLevel2(st, data) {
        return prodexpVendorService.RejectProdExpVendorRequestLevel2(
            data,
            st.rootState.auth.idToken
        );
    },
    RejectVendorValidation(st, data) {
        return prodexpVendorService.RejectVendorValidation(
            data,
            st.rootState.auth.idToken
        );
    },
    ApproveProdExpenseRequestLevel3(st, data) {
        return prodexpVendorService.ApproveProdExpVendorRequestLevel3(
            data,
            st.rootState.auth.idToken
        );
    },
    PendingVendorApproveorComplete(st, data) {
        return prodexpVendorService.PendingVendorApproveorComplete(
            data,
            st.rootState.auth.idToken
        );
    },

    RejectProdExpVendorRequestLevel3(st, data) {
        return prodexpVendorService.RejectProdExpVendorRequestLevel3(
            data,
            st.rootState.auth.idToken
        );
    },
    AccountingApprove(st, data) {
        return prodexpVendorService.AccountingApprove(
            data,
            st.rootState.auth.idToken
        );
    },
    AccountingReject(st, data) {
        return prodexpVendorService.AccountingReject(
            data,
            st.rootState.auth.idToken
        );
    },
    CFOApprove(st, data) {
        return prodexpVendorService.CFOApprove(
            data,
            st.rootState.auth.idToken
        );
    },
    CFOReject(st, data) {
        return prodexpVendorService.CFOReject(
            data,
            st.rootState.auth.idToken
        );
    },
    CompleteProdExpVendorRequest(st, data) {
        return prodexpVendorService.CompleteProdExpVendorRequest(
            data,
            st.rootState.auth.idToken
        );
    },
    ReassignDirectorApproval(st, data) {
        return prodexpVendorService.ReassignDirectorApproval(data, st.rootState.auth.idToken);
    },
    GetAuditFormData(st, id) {
        return prodexpVendorService.GetAuditFormData(id, st.rootState.auth.idToken);
    },
    GetWorkflowStates(st, id) {
        return prodexpVendorService.GetWorkflowStates(
            id,
            st.rootState.auth.idToken
        );
    },
    GetWorkflowHistoryStates(st, id) {
        return prodexpVendorService.GetWorkflowHistoryStates(
            id,
            st.rootState.auth.idToken
        );
    },
    GetRequestorById(st, id) {
        return prodexpVendorService.GetRequestorById(
            id,
            st.rootState.auth.idToken
        );
    },
    SaveRequestAsDraft(st, draftRequestId) {
        var DraftObj = {};
        DraftObj.DraftRequestID =
            draftRequestId != null && !isNaN(draftRequestId) ?
            parseInt(draftRequestId) :
            null;
        DraftObj.EmployeePhoneNumber = st.getters.ProdExpVendor.Phone;
        DraftObj.Entity = st.getters.ProdExpVendor.Entity;
        DraftObj.EmployeeAgency = st.getters.ProdExpVendor.EmployeeAgency;
        DraftObj.AgencyName = st.getters.ProdExpVendor.AgencyName;
        DraftObj.RequestType = st.getters.ProdExpVendor.RequestType;
        DraftObj.Files = [];
        let CompletedForms = st.getters.ProdExpVendor.CompletedForms;
        if (CompletedForms != null && CompletedForms.length > 0) {
            CompletedForms.forEach(completedForms => {
                DraftObj.Files.push({ Category: `CompletedForms`, Name: completedForms.Name || completedForms.name })
            });
        }
        DraftObj.VendorBusinessName = st.getters.ProdExpVendor.VendorBusinessName;
        DraftObj.IdentificationType = st.getters.ProdExpVendor.IdentificationType;
        DraftObj.USTaxID = st.getters.ProdExpVendor.USTaxID;
        DraftObj.Foreign = st.getters.ProdExpVendor.Foreign;
        DraftObj.SocialSecurityNumber = st.getters.ProdExpVendor.SocialSecurityNumber;
        let IdentificationFiles = st.getters.ProdExpVendor.IdentificationFiles;
        if (IdentificationFiles != null && IdentificationFiles.length > 0) {
            IdentificationFiles.forEach(identificationFiles => {
                DraftObj.Files.push({ Category: `IdentificationFiles`, Name: identificationFiles.Name || identificationFiles.name })
            });
        }
        DraftObj.IssuedName = st.getters.ProdExpVendor.IssuedName;
        DraftObj.VendorTIN = st.getters.ProdExpVendor.VendorTIN;
        DraftObj.VendorWebsiteLink = st.getters.ProdExpVendor.VendorWebsiteLink;
        let MediaKitAttachments = st.getters.ProdExpVendor.MediaKitAttachments;
        if (MediaKitAttachments != null && MediaKitAttachments.length > 0) {
            MediaKitAttachments.forEach(mediaKitAttachments => {
                DraftObj.Files.push({ Category: `MediaKitAttachments`, Name: mediaKitAttachments.Name || mediaKitAttachments.name })
            });
        }
        DraftObj.VendorRemittanceName = st.getters.ProdExpVendor.VendorRemittanceName;
        DraftObj.RemittanceCountry = st.getters.ProdExpVendor.RemittanceCountry;
        DraftObj.StreetAddressLine1 = st.getters.ProdExpVendor.StreetAddressLine1;
        DraftObj.StreetAddressLine2 = st.getters.ProdExpVendor.StreetAddressLine2;
        DraftObj.RemittanceCity = st.getters.ProdExpVendor.RemittanceCity;
        DraftObj.RemittanceState = st.getters.ProdExpVendor.RemittanceState;
        DraftObj.RemittanceZipCode = st.getters.ProdExpVendor.RemittanceZipCode;
        DraftObj.RemittanceEmail = st.getters.ProdExpVendor.RemittanceEmail;
        DraftObj.InfoFromName = st.getters.ProdExpVendor.InfoFromName;
        DraftObj.InfoFromTitle = st.getters.ProdExpVendor.InfoFromTitle;
        DraftObj.InfoFromPhone = st.getters.ProdExpVendor.InfoFromPhone;
        DraftObj.InvoicesImmediatePayment = st.getters.ProdExpVendor.InvoicesImmediatePayment;
        let InvoiceCopies = st.getters.ProdExpVendor.InvoiceCopies;
        if (InvoiceCopies != null && InvoiceCopies.length > 0) {
            InvoiceCopies.forEach(invoiceCopies => {
                DraftObj.Files.push({ Category: `InvoiceCopies`, Name: invoiceCopies.Name || invoiceCopies.name })
            });
        }
        DraftObj.BankName = st.getters.ProdExpVendor.BankName;
        DraftObj.BankCountry = st.getters.ProdExpVendor.BankCountry;
        DraftObj.BankAddressLine1 = st.getters.ProdExpVendor.BankAddressLine1;
        DraftObj.BankAddressLine2 = st.getters.ProdExpVendor.BankAddressLine2;
        DraftObj.BankState = st.getters.ProdExpVendor.BankState;
        DraftObj.BankCity = st.getters.ProdExpVendor.BankCity;
        DraftObj.BankZipCode = st.getters.ProdExpVendor.BankZipCode;
        DraftObj.BankAccountName = st.getters.ProdExpVendor.BankAccountName;
        DraftObj.BankAccountNumber = st.getters.ProdExpVendor.BankAccountNumber;
        DraftObj.BankIBAN = st.getters.ProdExpVendor.BankIBAN;
        DraftObj.BankSWIFTCode = st.getters.ProdExpVendor.BankSWIFTCode;
        DraftObj.BankRoutingNumber = st.getters.ProdExpVendor.BankRoutingNumber;
        DraftObj.RemittanceAdviceEmail = st.getters.ProdExpVendor.RemittanceAdviceEmail;
        let WireInfoSheets = st.getters.ProdExpVendor.WireInfoSheets;
        if (WireInfoSheets != null && WireInfoSheets.length > 0) {
            WireInfoSheets.forEach(wireInfoSheets => {
                DraftObj.Files.push({ Category: `WireInfoSheets`, Name: wireInfoSheets.Name || wireInfoSheets.name })
            });
        }
        DraftObj.TypeOfProductOrServiceProvidedByVendor = st.getters.ProdExpVendor.ProductService;
        DraftObj.DollarsAnticipatedToConductAnnuallyByVendor = st.getters.ProdExpVendor.DollarsAnticipatedToConductAnnuallyByVendor;
        let ServiceInfoFiles = st.getters.ProdExpVendor.ServiceInfoFiles;
        if (ServiceInfoFiles != null && ServiceInfoFiles.length > 0) {
            ServiceInfoFiles.forEach(serviceInfoFiles => {
                DraftObj.Files.push({ Category: `ServiceInfoFiles`, Name: serviceInfoFiles.Name || serviceInfoFiles.name })
            });
        }
        let CreditCardFiles = st.getters.ProdExpVendor.CreditCardFiles;
        if (CreditCardFiles != null && CreditCardFiles.length > 0) {
            CreditCardFiles.forEach(creditCardFiles => {
                DraftObj.Files.push({ Category: `CreditCardFiles`, Name: creditCardFiles.Name || creditCardFiles.name })
            });
        }
        let VendorConfirmationEmail = st.getters.ProdExpVendor.VendorConfirmationEmail;
        if (VendorConfirmationEmail != null && VendorConfirmationEmail.length > 0) {
            VendorConfirmationEmail.forEach(vendorConfirmationEmail => {
                DraftObj.Files.push({ Category: `VendorConfirmationEmail`, Name: vendorConfirmationEmail.Name || vendorConfirmationEmail.name })
            });
        }
        DraftObj.EmployeeVendorRelationship =
            (st.getters.ProdExpVendor.EmployeeVendorRelationship || []).map(name => ({
                ID: 0,
                RelationshipName: name
            }));
        DraftObj.EmployeeVendorRelationshipDetails = st.getters.ProdExpVendor.EmployeeVendorRelationshipDetails;
        DraftObj.EmployeeVendorRelationshipDetails.ID = 0;
        DraftObj.AnyGiftOrCompensationOfferedToYouToPlaceOrder = st.getters.ProdExpVendor.Compensation == "YES" ? true : st.getters.ProdExpVendor.Compensation == "NO" ? false : null;
        DraftObj.AdditionalApproval = st.getters.ProdExpVendor.AdditionalApproval;
        DraftObj.CompensationDollers = st.getters.ProdExpVendor.CompensationDollers;
        const draftFieldsToConvert = [
            "FormerEmployeeReimbursement",
            "IsVendorReceive1099",
            "IsIssuedNameEIN",
            "IsVendorWebsiteProvided",
            "HasBankLetterInvoice",
            "Accept",
            "IsPaidByWire",
            "IsACHPayment"
        ];
        draftFieldsToConvert.forEach(field => {
            DraftObj[field] = st.getters.ProdExpVendor[field];
            if (st.getters.ProdExpVendor[field] === "true" || st.getters.ProdExpVendor[field] === "YES") {
                DraftObj[field] = true;
            } else if (st.getters.ProdExpVendor[field] === "false" || st.getters.ProdExpVendor[field] === "NO") {
                DraftObj[field] = false;
            } else {
                DraftObj[field] = null;
            }
        });
        let formData = new FormData();
        formData.append("request", JSON.stringify(DraftObj));

        for (let i = 0; i < CompletedForms.length; i++) {
            let file = CompletedForms[i];
            formData.append(`CompletedForms`, file.file);
        }
        for (let j = 0; j < IdentificationFiles.length; j++) {
            let file = IdentificationFiles[j];
            formData.append(`IdentificationFiles`, file.file);
        }
        for (let k = 0; k < MediaKitAttachments.length; k++) {
            let file = MediaKitAttachments[k];
            formData.append(`MediaKitAttachments`, file.file);
        }
        for (let l = 0; l < InvoiceCopies.length; l++) {
            let file = InvoiceCopies[l];
            formData.append(`InvoiceCopies`, file.file);
        }
        for (let m = 0; m < WireInfoSheets.length; m++) {
            let file = WireInfoSheets[m];
            formData.append(`WireInfoSheets`, file.file);
        }
        for (let o = 0; o < ServiceInfoFiles.length; o++) {
            let file = ServiceInfoFiles[o];
            formData.append(`ServiceInfoFiles`, file.file);
        }
        for (let o = 0; o < CreditCardFiles.length; o++) {
            let file = CreditCardFiles[o];
            formData.append(`CreditCardFiles`, file.file);
        }
        for (let o = 0; o < VendorConfirmationEmail.length; o++) {
            let file = VendorConfirmationEmail[o];
            formData.append(`VendorConfirmationEmail`, file.file);
        }
        return prodexpVendorService.SaveRequestAsDraft(st.rootState.auth.idToken, formData);
    },
    GetDraftRequest(st, id) {
        prodexpVendorService
            .GetDraftRequest(id, st.rootState.auth.idToken)
            .then((res) => {
                st.commit("loadVendorData", res.data);
                st.commit("loadVendorFiles", res.data);
                return res.data;
            })
            .catch((error) => {
                return error;
            });
    },
    DeleteDraft(st, id) {
        return prodexpVendorService.DeleteDraft(st.rootState.auth.idToken, id);
    },
};

function GetFilesCategory() {
    return [
        "WireInfoSheets",
        "IdentificationFiles",
        "ServiceInfoFiles",
        "CompletedForms",
        "InvoiceCopies",
        "MediaKitAttachments",
        "CreditCardFiles",
        "VendorConfirmationEmail"
    ];
}

// mutations
const mutations = {
    reset(st) {
        const s = getDefaultState();
        Object.keys(st).forEach((d) => {
            st[d] = s[d];
        });
    },
    loadVendorData(state, data) {
        Object.assign(state.ProdExpVendor, data);
        state.ProdExpVendor.Status = data.Status;
        state.ProdExpVendor.Phone = data.EmployeePhoneNumber;
        state.ProdExpVendor.Entity = data.Entity;
        state.ProdExpVendor.EmployeeAgency = data.EmployeeAgency;
        state.ProdExpVendor.AgencyName = data.AgencyName;
        state.ProdExpVendor.InfoFromPhone = data.InfoFromPhone;
        state.ProdExpVendor.IsPaidByWire =
            data.IsPaidByWire === true ?
            "YES" :
            data.IsPaidByWire === false ?
            "NO" :
            null;
        state.ProdExpVendor.IsACHPayment =
            data.IsACHPayment === true ?
            "YES" :
            data.IsACHPayment === false ?
            "NO" :
            null;

        state.ProdExpVendor.ProductService = data.TypeOfProductOrServiceProvidedByVendor;

        state.ProdExpVendor.Compensation =
            data.AnyGiftOrCompensationOfferedToYouToPlaceOrder === true ?
            "YES" :
            data.AnyGiftOrCompensationOfferedToYouToPlaceOrder === false ?
            "NO" :
            null;

        state.ProdExpVendor.IsVendorReceive1099 =
            data.IsVendorReceive1099 === true ?
            "YES" :
            data.IsVendorReceive1099 === false ?
            "NO" :
            null;

        state.ProdExpVendor.IsIssuedNameEIN =
            data.IsIssuedNameEIN === true ?
            "YES" :
            data.IsIssuedNameEIN === false ?
            "NO" :
            null;

        state.ProdExpVendor.HasBankLetterInvoice =
            data.HasBankLetterInvoice === true ?
            "YES" :
            data.HasBankLetterInvoice === false ?
            "NO" :
            null;

        state.ProdExpVendor.FormerEmployeeReimbursement =
            data.FormerEmployeeReimbursement === true ?
            "true" :
            data.FormerEmployeeReimbursement === false ?
            "false" :
            null;

        state.ProdExpVendor.IsVendorWebsiteProvided =
            data.IsVendorWebsiteProvided === true ?
            "true" :
            data.IsVendorWebsiteProvided === false ?
            "false" :
            null;
        state.ProdExpVendor.EmployeeVendorRelationship = [];
        if (data.EmployeeVendorRelationship != null) {
            data.EmployeeVendorRelationship.forEach((val) => {
                state.ProdExpVendor.EmployeeVendorRelationship.push(val.RelationshipName);
            });
        }
    },
    loadVendorFiles(state, data) {
        if (data.Files.length > 0) {
            GetFilesCategory().forEach((file) => {
                if (typeof file == "undefined" || file == null) {
                    return;
                } else {
                    let files = data.Files.filter((catFile) => {
                        return catFile.Category == file;
                    });
                    if (files.length > 0) {
                        files.forEach((originalFile) => {
                            state.ProdExpVendor[file].push(originalFile);
                        });
                    }
                }
            });
        }
        state.ProdExpVendor.IsEditDataLoaded = true;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};